console.log("in lab form js files", productInfo);

function submitFormToAPI(formData) {
  // $(".spinner").show();

  productInfo.forEach((item) => {
    if (
      item.properties._method === "PHLEB-NURSE" ||
      item.properties._method_sku === "PHLEB-NURSE"
    ) {
      item.examType = 1;
    } else {
      item.examType = 2;
    }
  });

  const requestBody = {
    ...formData,
    user_id: userId,
    shopify_order_id: orderId,
    product_info: productInfo,
    with_gp_review: formData.with_gp_review ? true : false,
  };

  // Prepare the data for the POST request
  var postData = {
    method: "POST",
    body: JSON.stringify(requestBody),
    headers: {
      "Content-Type": "application/json",
    },
  };

  const order_url = `${backend_url}/order/create`;

  // Send the POST request
  fetch(order_url, postData)
    .then((response) => response.json())
    .then((data) => {
      Toastify({
        text: "Lab form submitted successfully!",
        duration: 3000,
        newWindow: true,
        close: true,
        style: {
          background: "#0BDA51",
        },
        gravity: "top", // `top` or `bottom`
        position: "right", // `left`, `center` or `right`
        stopOnFocus: true, // Prevents dismissing of toast on hover
      }).showToast();

      window.location.href = "/account";
      $(".spinner").hide();
    })
    .catch((error) => {
      Toastify({
        text: "Error submitting form. Please try again.",
        duration: 3000,
        newWindow: true,
        close: true,
        style: {
          background: "#FF0000",
        },
        gravity: "top", // `top` or `bottom`
        position: "right", // `left`, `center` or `right`
        stopOnFocus: true, // Prevents dismissing of toast on hover
      }).showToast();

      $(".spinner").hide();
      console.error("Error:", error);
    });
}

document
  .getElementById("lab-form")
  .addEventListener("submit", function (event) {
    event.preventDefault();

    var formData = new FormData(this);
    var formValues = {};

    formData.forEach(function (value, key) {
      var keys = key.match(/[^\[\]]+/g); // Extract keys between '[' and ']'

      var currentObj = formValues;
      for (var i = 0; i < keys.length; i++) {
        if (!currentObj[keys[i]]) {
          currentObj[keys[i]] = i === keys.length - 1 ? value : {}; // Assign value only for the last key
        }
        currentObj = currentObj[keys[i]];
      }
    });

    // Call your API submission function with formValues
    submitFormToAPI(formValues);
  });
